module.exports = __webpack_public_path__ + "static/___008___A-new-beginning.3a70e0cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___008___A-new-beginning.jpg
// module id = 1284
// module chunks = 64098118039141